import { BrowserRouter } from "react-router-dom";

import { Contratos } from "./modules/Contratos";
import Dashboard from "./modules/Dashboard";
import Estoque from "./modules/Estoque";
import Faturamento from "./modules/Faturamento";
import Financeiro from "./modules/Financeiro";
import Optica from "./modules/Optica";
import Prouser from "./modules/Prouser";
import Site from "./modules/Site";
import TemplateEmails from "./modules/TemplateEmails";
import Vendas from "./modules/Vendas";
import ComponentesErp from "./modules/ComponentesErp";

const Routes = () => {
  return (
    <>
      <BrowserRouter>
        <Estoque />
        <Dashboard />
        <Financeiro />
        <Contratos />
        <Vendas />
        <Prouser />
        <Faturamento />
        <TemplateEmails />
        <Optica />
        <Site />
        <ComponentesErp />
      </BrowserRouter>
    </>
  );
};

export default Routes;
